import React from 'react';
import { styled } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { Chip, Grid } from '@mui/material';
import useStyles from '../styles';

const CssTextField = styled(TextField)(() => ({
    // marginLeft: '15px',
    // marginTop: '8px',
    margin: '8px 0px 0px 4px',
    width: '85%',
    input: {
        height: '0px',
        justifyContent: 'center',
        padding: '11.5px 10px',
        border: '1px solid #70707063',
        borderRadius: '0px !important'
    }
}));

export default function CreateApi(props) {
    const classes = useStyles();
    const decimalVal = (event) => {
        if (event.key === '.' || event.key === '-') {
            event.preventDefault();
        }
    };
    return (
        <>
            <div className={classes.boxContainer}>
                <Grid>
                    <Chip
                        style={{
                            color: '#4E4E4E',
                            fontWeight: 'bold'
                        }}
                        className={classes.boxHead}
                        label={props.label}
                    />
                    <div className={classes.boxFlex}>
                        <Grid container>
                            <div className={classes.formTextFirst}>Minute</div>{' '}
                            <FormControl sx={{ width: 120 }}>
                                <CssTextField
                                    type="number"
                                    id="small"
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                    onKeyDown={decimalVal}
                                    error={props.value.minute < 0 || props.value.minute === ''}
                                    helperText={
                                        (props.value.minute < 0 && 'Invalid data') ||
                                        (props.value.minute === '' && 'Field cannot be empty')
                                    }
                                    onChange={props.usageChange(props.name, 'minute')}
                                    value={props.value.minute}
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                        style: { fontSize: '13px' }
                                    }}
                                />
                            </FormControl>
                        </Grid>
                    </div>
                    <div className={classes.boxFlex}>
                        <Grid container>
                            <div className={classes.formTextFirst}>Hourly</div>{' '}
                            <FormControl sx={{ width: 120 }}>
                                <CssTextField
                                    type="number"
                                    id="small"
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                    error={props.value.hourly < 0 || props.value.hourly === ''}
                                    helperText={
                                        (props.value.hourly < 0 && 'Invalid data') ||
                                        (props.value.hourly === '' && 'Field cannot be empty')
                                    }
                                    onKeyDown={decimalVal}
                                    onChange={props.usageChange(props.name, 'hourly')}
                                    value={props.value.hourly}
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                        style: { fontSize: '13px' }
                                    }}
                                />
                            </FormControl>
                        </Grid>
                    </div>
                    <div className={classes.boxFlex}>
                        <Grid container>
                            <div className={classes.formTextFirst}>Monthly</div>{' '}
                            <FormControl sx={{ width: 120 }}>
                                <CssTextField
                                    type="number"
                                    id="small"
                                    FormHelperTextProps={{
                                        className: classes.helperText
                                    }}
                                    error={props.value.monthly < 0 || props.value.monthly === ''}
                                    helperText={
                                        (props.value.monthly < 0 && 'Invalid data') ||
                                        (props.value.monthly === '' && 'Field cannot be empty')
                                    }
                                    onKeyDown={decimalVal}
                                    onChange={props.usageChange(props.name, 'monthly')}
                                    value={props.value.monthly}
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                        style: { fontSize: '13px' }
                                    }}
                                />
                            </FormControl>
                        </Grid>
                    </div>
                </Grid>
            </div>
        </>
    );
}
